document.addEventListener('DOMContentLoaded', function(){
  let lastScrollTop = window.pageYOffset;
  
  window.addEventListener('scroll', function(e){
    const scrollTop = window.pageYOffset;
    const headerHeight = document.getElementById('header').clientHeight;
    const body = document.querySelector('body');
    
    if(scrollTop > headerHeight && scrollTop > lastScrollTop) {
      body.classList.add('sticky-header-up');
    } else {
      body.classList.remove('sticky-header-up');
    }

    lastScrollTop = scrollTop;
  });
});